import React from "react";

// How often an issue may appear in the regular reminder email.
export const REMINDERS = [
    { value: "weekly", label: "Weekly", help: "Every Wednesday at 10:00, but only when it needs attention: overdue, due within 2 weeks, or no update for 2 weeks." },
    { value: "monthly", label: "Monthly", help: "As weekly, but at most once every 4 weeks. Good for long jobs." },
];

export const reminderLabel = (value) => (REMINDERS.find((r) => r.value === value) || REMINDERS[0]).label;

export const STATUSES = ["Pending", "In progress", "Closed"];

const STATUS_BADGE = {
    "Pending": "is-info",
    "In progress": "is-pending",
    "On hold": "is-bad", // older history entries only
    "Closed": "is-ok",
};

export function StatusBadge({ status }) {
    return <span className={`cf-badge ${STATUS_BADGE[status] || "is-info"}`}>{status}</span>;
}

// "Due in 3 days", "Due today", "Overdue by 2 days", "No deadline"
export function DeadlineNote({ issue }) {
    if (!issue.deadline) return <span className="cf-muted">No deadline</span>;
    if (issue.status === "Closed") return null;

    const days = issue.days_left;
    if (days < 0) return <span className="cf-issue-late">Overdue by {Math.abs(days)} day{Math.abs(days) === 1 ? "" : "s"}</span>;
    if (days === 0) return <span className="cf-issue-soon">Due today</span>;
    if (days <= 3) return <span className="cf-issue-soon">Due in {days} day{days === 1 ? "" : "s"}</span>;
    return <span className="cf-muted">Due in {days} days</span>;
}
